let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("3nP2r"), load("13UzD")]).then(() => parcelRequire('aUJ5R'));